import { PayloadAction } from '@reduxjs/toolkit';

import { AntdTableResponseOfListOfEventLogDto, EventLogClient, EventLogDto, EventLogSearchDto } from '@medone/medonehp-api-client';

import { handleError } from '../../../../shared/common/HandleErrors';
import { Axios } from '../../../../shared/common/http';
import { AppDispatch, AppThunk, RootState } from '../../../../shared/store';
import { AdminState } from './models';
import { setEventLogFilter, setEventLogs } from './slice';

export const reducers = {
    setEventLogs: (state: AdminState, action: PayloadAction<AntdTableResponseOfListOfEventLogDto>) => {
        state.eventLogs = action.payload;
        state.errorMessage = null;
    },

    setEventLogFilter: (state: AdminState, action: PayloadAction<EventLogSearchDto>) => {
        state.eventLogFilter = action.payload;
    },

    syncEventLog: (state: AdminState, action: PayloadAction<EventLogDto>) => {
        let newItems = [...state.eventLogs.entity];
        const index = state.eventLogs.entity.findIndex((x) => x.id === action.payload.id);

        if (index !== -1) {
            newItems = newItems.map((item) => {
                if (item.id === action.payload.id) {
                    return { ...item, ...action.payload } as EventLogDto;
                }

                return item;
            });
        } else {
            newItems.push(action.payload);
        }

        state.eventLogs.entity = newItems;
    },
};

export function fetchEventLogs(dto: EventLogSearchDto): AppThunk {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(setEventLogFilter(dto));

        const client = new EventLogClient(null, Axios);

        try {
            const response = await client.getEventLogs(dto);

            if (response.result.succeeded) {
                dispatch(setEventLogs(response.result));
            } else {
                handleError(response);
            }
        } catch (error) {
            handleError(error);
        }
    };
}

export const selectEventLogs = (state: RootState) => state.admin.eventLogs;
